import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";
import { NeuCard } from "../../components/neu/Neu";
import { effectivePolicy } from "../../api/directory";

const LABELS = {
  daily_grace_minutes: "branches.dailyGrace",
  monthly_extra_late_allowance: "branches.monthlyExtraLate",
  extra_late_minutes: "branches.extraLateMinutes",
  checkout_grace_minutes: "branches.checkoutGrace",
  early_checkin_minutes: "branches.earlyCheckin",
};

const TONE = {
  branch: "text-primary",
  company: "text-amber-500",
  default: "text-muted-foreground",
  enforced_minimum: "text-destructive",
};

// السياسة المُطبَّقة فعلياً على هذا الفرع ومصدر كل قيمة (للقراءة فقط).
export const EffectivePolicyCard = ({ branchId }) => {
  const { t } = useTranslation();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    effectivePolicy(branchId)
      .then((data) => setRows(data.fields))
      .catch(() => setRows([]));
  }, [branchId]);

  if (!rows?.length) return null;

  return (
    <NeuCard data-testid="effective-policy-card">
      <p className="label-xs flex items-center gap-2">
        <ShieldCheck className="h-4 w-4 text-primary" /> {t("branches.effectiveTitle")}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">{t("branches.effectiveHint")}</p>
      <dl className="mt-4 grid gap-3 sm:grid-cols-2">
        {rows.map((row) => (
          <div key={row.key} className="rounded-2xl p-3 shadow-neu-in" data-testid={`effective-${row.key}`}>
            <dt className="text-[11px] font-bold text-muted-foreground">{t(LABELS[row.key])}</dt>
            <dd className="mt-1 flex items-baseline gap-2">
              <span className="font-mono text-lg font-black">{row.value}</span>
              {row.key === "monthly_extra_late_allowance" ? null : (
                <span className="text-[11px] text-muted-foreground">{t("app.minutes")}</span>
              )}
              <span className={`ms-auto text-[11px] font-bold ${TONE[row.source]}`}>
                {t(`branches.source.${row.source}`)}
              </span>
            </dd>
          </div>
        ))}
      </dl>
    </NeuCard>
  );
};
